import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5"
import { useMemberGuideList } from "../../../../hooks/manageMembers/useMemberGuideList";
import { ProfileMemberGuideInput } from "./components/ProfileMemberGuideInput";
import { ApiMember } from "../../../manageMembers/models/ManageMemberModel";


type Props = {
    defaulValue: ApiMember | null;
    show: boolean;
    onHide: () => void;
    onUpdate: (value: ApiMember | null) => void;
}
export const ProfileMemberGuideModal = ({ defaulValue, show, onHide, onUpdate }: Props) => {
    const [memberSelected, setMemberSelected] = useState<ApiMember | null>(defaulValue);
    useEffect(() => {
        setMemberSelected(defaulValue);
    }, [defaulValue]);
    
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            dialogClassName="nb-pmg-wrap"
            contentClassName="nb-pmg"
        >
            <h3>Add Member</h3>
            <span className="nb_pmg__body">Select only one member</span>

            <ProfileMemberGuideInput
                value={memberSelected}
                onChange={setMemberSelected}
            />

            <div className="nb-pmg__actions">
                <button className="nb-pmg__actions__secundary" onClick={onHide}>
                    Cancel
                </button>
                <button className="nb-pmg__actions__primary" onClick={() => onUpdate(memberSelected)}>
                    Approve
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                        <path d="M8.5 0.378906L12 3.38306H0" stroke="white"/>
                    </svg>
                </button>
            </div>
        </Modal>
    )
} 